(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-json.js', './kotlinx-serialization-kotlinx-serialization-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'PaymentsKit-common'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'PaymentsKit-common'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'PaymentsKit-common'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'PaymentsKit-common'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'PaymentsKit-common'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'PaymentsKit-common'.");
    }
    globalThis['PaymentsKit-common'] = factory(typeof globalThis['PaymentsKit-common'] === 'undefined' ? {} : globalThis['PaymentsKit-common'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-serialization-kotlinx-serialization-json'], globalThis['kotlinx-serialization-kotlinx-serialization-core']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Unit_instance = kotlin_kotlin.$_$.p2;
  var VOID = kotlin_kotlin.$_$.b;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p1;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.q2;
  var lazy = kotlin_kotlin.$_$.od;
  var protoOf = kotlin_kotlin.$_$.ba;
  var initMetadataForCompanion = kotlin_kotlin.$_$.f9;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
  var emptyList = kotlin_kotlin.$_$.e5;
  var equals = kotlin_kotlin.$_$.y8;
  var THROW_CCE = kotlin_kotlin.$_$.tc;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k;
  var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var initMetadataForObject = kotlin_kotlin.$_$.j9;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var objectCreate = kotlin_kotlin.$_$.aa;
  var toString = kotlin_kotlin.$_$.da;
  var getStringHashCode = kotlin_kotlin.$_$.c9;
  var getBooleanHashCode = kotlin_kotlin.$_$.z8;
  var hashCode = kotlin_kotlin.$_$.d9;
  var initMetadataForClass = kotlin_kotlin.$_$.e9;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s;
  var SerializableWith = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j2;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PaymentMethodDto, 'PaymentMethodDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForCompanion(Companion_0);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PaymentsPublicConfigDto, 'PaymentsPublicConfigDto', PaymentsPublicConfigDto, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  initMetadataForCompanion(Companion_1);
  initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupIntentsResponseDto, 'SetupIntentsResponseDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ProviderSetupIntentDto, 'ProviderSetupIntentDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  //endregion
  function get_paymentsKitJson() {
    _init_properties_PaymentsHttpClient_kt__2t71cw();
    return paymentsKitJson;
  }
  var paymentsKitJson;
  function paymentsKitJson$lambda($this$Json) {
    _init_properties_PaymentsHttpClient_kt__2t71cw();
    $this$Json.a14_1 = true;
    return Unit_instance;
  }
  var properties_initialized_PaymentsHttpClient_kt_msimpu;
  function _init_properties_PaymentsHttpClient_kt__2t71cw() {
    if (!properties_initialized_PaymentsHttpClient_kt_msimpu) {
      properties_initialized_PaymentsHttpClient_kt_msimpu = true;
      paymentsKitJson = Json(VOID, paymentsKitJson$lambda);
    }
  }
  function PaymentMethodDto$Companion$$childSerializers$_anonymous__urqr3i() {
    return new ArrayListSerializer(StringSerializer_getInstance());
  }
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l1e_1 = [null, null, null, null, null, null, lazy(tmp_0, PaymentMethodDto$Companion$$childSerializers$_anonymous__urqr3i)];
  }
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.payments.PaymentMethodDto', this, 7);
    tmp0_serialDesc.tt('id', false);
    tmp0_serialDesc.tt('brand', false);
    tmp0_serialDesc.tt('last4', false);
    tmp0_serialDesc.tt('expMonth', false);
    tmp0_serialDesc.tt('expYear', false);
    tmp0_serialDesc.tt('isDefault', false);
    tmp0_serialDesc.tt('providers', true);
    this.m1e_1 = tmp0_serialDesc;
  }
  protoOf($serializer).n1e = function (encoder, value) {
    var tmp0_desc = this.m1e_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance().l1e_1;
    tmp1_output.un(tmp0_desc, 0, value.o1e_1);
    tmp1_output.un(tmp0_desc, 1, value.p1e_1);
    tmp1_output.un(tmp0_desc, 2, value.q1e_1);
    tmp1_output.pn(tmp0_desc, 3, value.r1e_1);
    tmp1_output.pn(tmp0_desc, 4, value.s1e_1);
    tmp1_output.mn(tmp0_desc, 5, value.t1e_1);
    if (tmp1_output.co(tmp0_desc, 6) ? true : !equals(value.u1e_1, emptyList())) {
      tmp1_output.wn(tmp0_desc, 6, tmp2_cached[6].f2(), value.u1e_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer).fj = function (encoder, value) {
    return this.n1e(encoder, value instanceof PaymentMethodDto ? value : THROW_CCE());
  };
  protoOf($serializer).gj = function (decoder) {
    var tmp0_desc = this.m1e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_local4 = 0;
    var tmp9_local5 = false;
    var tmp10_local6 = null;
    var tmp11_input = decoder.fm(tmp0_desc);
    var tmp12_cached = Companion_getInstance().l1e_1;
    if (tmp11_input.vm()) {
      tmp4_local0 = tmp11_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.km(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.km(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.hm(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.rm(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.km(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.km(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.hm(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.rm(tmp0_desc, 6, tmp12_cached[6].f2(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.gm(tmp0_desc);
    return PaymentMethodDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer).ej = function () {
    return this.m1e_1;
  };
  protoOf($serializer).iu = function () {
    var tmp0_cached = Companion_getInstance().l1e_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[6].f2()];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function PaymentMethodDto_init_$Init$(seen0, id, brand, last4, expMonth, expYear, isDefault, providers, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance().m1e_1);
    }
    $this.o1e_1 = id;
    $this.p1e_1 = brand;
    $this.q1e_1 = last4;
    $this.r1e_1 = expMonth;
    $this.s1e_1 = expYear;
    $this.t1e_1 = isDefault;
    if (0 === (seen0 & 64))
      $this.u1e_1 = emptyList();
    else
      $this.u1e_1 = providers;
    return $this;
  }
  function PaymentMethodDto_init_$Create$(seen0, id, brand, last4, expMonth, expYear, isDefault, providers, serializationConstructorMarker) {
    return PaymentMethodDto_init_$Init$(seen0, id, brand, last4, expMonth, expYear, isDefault, providers, serializationConstructorMarker, objectCreate(protoOf(PaymentMethodDto)));
  }
  function PaymentMethodDto(id, brand, last4, expMonth, expYear, isDefault, providers) {
    Companion_getInstance();
    providers = providers === VOID ? emptyList() : providers;
    this.o1e_1 = id;
    this.p1e_1 = brand;
    this.q1e_1 = last4;
    this.r1e_1 = expMonth;
    this.s1e_1 = expYear;
    this.t1e_1 = isDefault;
    this.u1e_1 = providers;
  }
  protoOf(PaymentMethodDto).toString = function () {
    return 'PaymentMethodDto(id=' + this.o1e_1 + ', brand=' + this.p1e_1 + ', last4=' + this.q1e_1 + ', expMonth=' + this.r1e_1 + ', expYear=' + this.s1e_1 + ', isDefault=' + this.t1e_1 + ', providers=' + toString(this.u1e_1) + ')';
  };
  protoOf(PaymentMethodDto).hashCode = function () {
    var result = getStringHashCode(this.o1e_1);
    result = imul(result, 31) + getStringHashCode(this.p1e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1e_1) | 0;
    result = imul(result, 31) + this.r1e_1 | 0;
    result = imul(result, 31) + this.s1e_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t1e_1) | 0;
    result = imul(result, 31) + hashCode(this.u1e_1) | 0;
    return result;
  };
  protoOf(PaymentMethodDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PaymentMethodDto))
      return false;
    if (!(this.o1e_1 === other.o1e_1))
      return false;
    if (!(this.p1e_1 === other.p1e_1))
      return false;
    if (!(this.q1e_1 === other.q1e_1))
      return false;
    if (!(this.r1e_1 === other.r1e_1))
      return false;
    if (!(this.s1e_1 === other.s1e_1))
      return false;
    if (!(this.t1e_1 === other.t1e_1))
      return false;
    if (!equals(this.u1e_1, other.u1e_1))
      return false;
    return true;
  };
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.payments.PaymentsPublicConfigDto', this, 2);
    tmp0_serialDesc.tt('stripePublishableKey', true);
    tmp0_serialDesc.tt('paypalClientId', true);
    this.v1e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).w1e = function (encoder, value) {
    var tmp0_desc = this.v1e_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    if (tmp1_output.co(tmp0_desc, 0) ? true : !(value.x1e_1 == null)) {
      tmp1_output.yn(tmp0_desc, 0, StringSerializer_getInstance(), value.x1e_1);
    }
    if (tmp1_output.co(tmp0_desc, 1) ? true : !(value.y1e_1 == null)) {
      tmp1_output.yn(tmp0_desc, 1, StringSerializer_getInstance(), value.y1e_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_0).fj = function (encoder, value) {
    return this.w1e(encoder, value instanceof PaymentsPublicConfigDto ? value : THROW_CCE());
  };
  protoOf($serializer_0).gj = function (decoder) {
    var tmp0_desc = this.v1e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.fm(tmp0_desc);
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.tm(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.tm(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return PaymentsPublicConfigDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_0).ej = function () {
    return this.v1e_1;
  };
  protoOf($serializer_0).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function PaymentsPublicConfigDto_init_$Init$(seen0, stripePublishableKey, paypalClientId, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_0().v1e_1);
    }
    if (0 === (seen0 & 1))
      $this.x1e_1 = null;
    else
      $this.x1e_1 = stripePublishableKey;
    if (0 === (seen0 & 2))
      $this.y1e_1 = null;
    else
      $this.y1e_1 = paypalClientId;
    return $this;
  }
  function PaymentsPublicConfigDto_init_$Create$(seen0, stripePublishableKey, paypalClientId, serializationConstructorMarker) {
    return PaymentsPublicConfigDto_init_$Init$(seen0, stripePublishableKey, paypalClientId, serializationConstructorMarker, objectCreate(protoOf(PaymentsPublicConfigDto)));
  }
  function PaymentsPublicConfigDto(stripePublishableKey, paypalClientId) {
    stripePublishableKey = stripePublishableKey === VOID ? null : stripePublishableKey;
    paypalClientId = paypalClientId === VOID ? null : paypalClientId;
    this.x1e_1 = stripePublishableKey;
    this.y1e_1 = paypalClientId;
  }
  protoOf(PaymentsPublicConfigDto).toString = function () {
    return 'PaymentsPublicConfigDto(stripePublishableKey=' + this.x1e_1 + ', paypalClientId=' + this.y1e_1 + ')';
  };
  protoOf(PaymentsPublicConfigDto).hashCode = function () {
    var result = this.x1e_1 == null ? 0 : getStringHashCode(this.x1e_1);
    result = imul(result, 31) + (this.y1e_1 == null ? 0 : getStringHashCode(this.y1e_1)) | 0;
    return result;
  };
  protoOf(PaymentsPublicConfigDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PaymentsPublicConfigDto))
      return false;
    if (!(this.x1e_1 == other.x1e_1))
      return false;
    if (!(this.y1e_1 == other.y1e_1))
      return false;
    return true;
  };
  function SetupIntentsResponseDto$Companion$$childSerializers$_anonymous__50r092() {
    return new ArrayListSerializer($serializer_getInstance_2());
  }
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z1e_1 = [lazy(tmp_0, SetupIntentsResponseDto$Companion$$childSerializers$_anonymous__50r092)];
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.payments.SetupIntentsResponseDto', this, 1);
    tmp0_serialDesc.tt('intents', false);
    this.a1f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).b1f = function (encoder, value) {
    var tmp0_desc = this.a1f_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_1().z1e_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.c1f_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_1).fj = function (encoder, value) {
    return this.b1f(encoder, value instanceof SetupIntentsResponseDto ? value : THROW_CCE());
  };
  protoOf($serializer_1).gj = function (decoder) {
    var tmp0_desc = this.a1f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    var tmp6_cached = Companion_getInstance_1().z1e_1;
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return SetupIntentsResponseDto_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_1).ej = function () {
    return this.a1f_1;
  };
  protoOf($serializer_1).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_1().z1e_1[0].f2()];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function SetupIntentsResponseDto_init_$Init$(seen0, intents, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_1().a1f_1);
    }
    $this.c1f_1 = intents;
    return $this;
  }
  function SetupIntentsResponseDto_init_$Create$(seen0, intents, serializationConstructorMarker) {
    return SetupIntentsResponseDto_init_$Init$(seen0, intents, serializationConstructorMarker, objectCreate(protoOf(SetupIntentsResponseDto)));
  }
  function SetupIntentsResponseDto(intents) {
    Companion_getInstance_1();
    this.c1f_1 = intents;
  }
  protoOf(SetupIntentsResponseDto).toString = function () {
    return 'SetupIntentsResponseDto(intents=' + toString(this.c1f_1) + ')';
  };
  protoOf(SetupIntentsResponseDto).hashCode = function () {
    return hashCode(this.c1f_1);
  };
  protoOf(SetupIntentsResponseDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupIntentsResponseDto))
      return false;
    if (!equals(this.c1f_1, other.c1f_1))
      return false;
    return true;
  };
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.payments.ProviderSetupIntentDto', this, 2);
    tmp0_serialDesc.tt('provider', false);
    tmp0_serialDesc.tt('clientSecret', false);
    this.d1f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).e1f = function (encoder, value) {
    var tmp0_desc = this.d1f_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.f1f_1);
    tmp1_output.un(tmp0_desc, 1, value.g1f_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_2).fj = function (encoder, value) {
    return this.e1f(encoder, value instanceof ProviderSetupIntentDto ? value : THROW_CCE());
  };
  protoOf($serializer_2).gj = function (decoder) {
    var tmp0_desc = this.d1f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.fm(tmp0_desc);
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return ProviderSetupIntentDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_2).ej = function () {
    return this.d1f_1;
  };
  protoOf($serializer_2).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function ProviderSetupIntentDto_init_$Init$(seen0, provider, clientSecret, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_2().d1f_1);
    }
    $this.f1f_1 = provider;
    $this.g1f_1 = clientSecret;
    return $this;
  }
  function ProviderSetupIntentDto_init_$Create$(seen0, provider, clientSecret, serializationConstructorMarker) {
    return ProviderSetupIntentDto_init_$Init$(seen0, provider, clientSecret, serializationConstructorMarker, objectCreate(protoOf(ProviderSetupIntentDto)));
  }
  function ProviderSetupIntentDto() {
  }
  protoOf(ProviderSetupIntentDto).toString = function () {
    return 'ProviderSetupIntentDto(provider=' + this.f1f_1 + ', clientSecret=' + this.g1f_1 + ')';
  };
  protoOf(ProviderSetupIntentDto).hashCode = function () {
    var result = getStringHashCode(this.f1f_1);
    result = imul(result, 31) + getStringHashCode(this.g1f_1) | 0;
    return result;
  };
  protoOf(ProviderSetupIntentDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProviderSetupIntentDto))
      return false;
    if (!(this.f1f_1 === other.f1f_1))
      return false;
    if (!(this.g1f_1 === other.g1f_1))
      return false;
    return true;
  };
  //region block: post-declaration
  protoOf($serializer).ju = typeParametersSerializers;
  protoOf($serializer_0).ju = typeParametersSerializers;
  protoOf($serializer_1).ju = typeParametersSerializers;
  protoOf($serializer_2).ju = typeParametersSerializers;
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = PaymentMethodDto;
  _.$_$.b = PaymentsPublicConfigDto;
  _.$_$.c = SetupIntentsResponseDto;
  _.$_$.d = get_paymentsKitJson;
  //endregion
  return _;
}));

